import { state, getters, mutations, actions } from './store';

export const name = '$_OperationsCalendarEvent';
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
